import React, { useContext, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PlayIcon from '@mui/icons-material/PlayArrow';
import StairsIcon from '@mui/icons-material/Stairs';
// import StarIcon from '@mui/icons-material/Star';
import ProgressBar from "@ramonak/react-progress-bar";
import HeartIcon from '@mui/icons-material/FavoriteBorder';
import HeartFilledIcon from '@mui/icons-material/Favorite';
import PersonsIcon from '@mui/icons-material/PersonAdd';
import { Oval } from 'react-loader-spinner'
import { Link, useNavigate } from 'react-router-dom';
import { baseUrl, path } from '../constants';
import { settingsContext } from '../Context/settingsProvider';
import LanguageIcon from '@mui/icons-material/Language';
import { api } from '../api';
import { appContext } from '../Context/appProvider';
import VerifiedIcon from '@mui/icons-material/Verified';
import { getHours, getRating } from '../Pages/CourseDetail/CourseDetail';

export default function CourseCard({ course, myTab, setSelectedCourse, instructor }) {
    const {addNotification, t} = useContext(settingsContext)
    const {token} = useContext(appContext)
    const [adding, setAdding] = useState(false)
    const [wished, setWished] = useState(!!course.wishlists?.length)
    const navigate = useNavigate()
    const self = myTab || course.enrollments?.length

    const addToWishlist = (e) => {
        if(!token) return navigate('/login')
        e.preventDefault(); 
        e.stopPropagation(); 
        // if(!token) return navigate('/login')
        setAdding(true)
        api.post(path.addToWishlist, {
            id: course.id
        }).then(response => {
            let data = response.data
            if(data.success){
                addNotification('success', data.message)
                setWished(w => !w)
            }
        }).finally(() => setAdding(false))
    }

  return (
    <div className='bg-white flex max-w-[320px] h-fit group max-md:max-w-[350px] flex-col gap-2 shadow-md hover:scale-105 max-md:hover:scale-100 transition-all cursor-pointer rounded-md overflow-hidden'>
        <div onClick={(e) => {
                setSelectedCourse(course)
            }} className='w-full bg-[#e8e8e8] flex items-center justify-center relative'>    
            <button
            className='transition hidden group-hover:scale-100 group-hover:flex w-[50px] absolute h-[50px] rounded-full rounded-full overflow-hidden items-center justify-center bg-[#00000095]'> 
                <PlayIcon style={{fontSize: 50, color: '#ffffff95', backgroundColor: 'transparent '}}>Filled</PlayIcon>
            </button>
            <img className='w-[320px] max-md:w-[350px] max-md:h-[197.5px] h-[180px] object-cover' src={baseUrl + course.thumbnail} alt='course'/>
        </div>
        <div className='p-2 pt-0 flex flex-col gap-4'>
        <div className='flex justify-between items-center px-2'>
            <div className='flex items-center gap-1 rounded-sm bg-black p-1 px-2'>
                <AccessTimeIcon style={{color: '#ffffff', fontSize: 13}}>Filled</AccessTimeIcon>
                <p className='text-white text-xs font-bold'>{getHours(course.sections)}</p>
            </div>
            <div className='flex items-center gap-1 '>
                <StarIcon style={{color: '#6622cf', fontSize: 13}}>Filled</StarIcon>
                <p className='text-black text-xs'>{getRating(course.rates)} ({course.rates?.length?.toLocaleString() || 0})</p>
            </div>

            <div className='flex items-center gap-1'>
                <PersonsIcon style={{color: '#000000', fontSize: 15}}>Filled</PersonsIcon>
                <p className='text-black text-xs'>{course?.enrollCount || 0}</p>
            </div>
        </div>
        {instructor ? (
             <p className='text-black text-[18px] font-bold'>{course.title}</p>
        ) : (
            <Link to={'/instructor/' + course.instructor?.id} className='flex items-center gap-2'>
                <img className='w-[50px] h-[50px] object-cover rounded-full' src={baseUrl + course.instructor?.image} />
                <div>
                    <Link to={(self ? '/learn/' : '/course/') + course.id} className='text-black text-[16px] font-bold truncate'>{course.title?.slice(0, 30)} {course.title?.length > 26 ? '...' : ''}</Link>
                    <div className='flex items-center gap-1'>
                        <p className='text-black text-xs'>{`${course.instructor?.sellerprofile?.name}`}</p>
                        <VerifiedIcon style={{color: '#6622cf', fontSize: 15}}>Filled</VerifiedIcon>
                    </div>
                </div>
            </Link>
        )}
        {/* {!instructor && (
            <p className='text-[#6a6f73] text-xs'>By {`${course.instructor.firstName} ${course.instructor.lastName}`}</p>
        )} */}
        {/* <div className='flex items-center gap-1'>
            <p className='text-black text-xs'>{0}</p>
            <StarIcon style={{color: 'black', fontSize: 12}}>Filled</StarIcon>
            <p className='text-black text-xs'>({0})</p>
        </div> */}
        {/* {noProg ? '' : self ? <ProgressBar completed={60} height={13} labelSize={10} bgColor='#198754' /> : <p className='text-black text-md font-bold'>ETB {price}</p> } */}
        <div className='flex justify-around items-center'>
            <p className='text-black text-xs'>{t('ETB')} <span className='text-[20px] font-bold'>{course.price?.toLocaleString('en-US', {maxFractionDigits: 2})}</span> {course.isFree && <span className='text-sm max-md:text-xs bg-black font-bold text-white px-2 py-1 rounded-sm'>FREE COURSE</span>}</p>
            {/* <p className='text-xs text-black'><span className='font-bold'>300+</span> Sells</p> */}
        </div>
        <div className='flex gap-1'>
            <Link to={(self ? '/learn/' : '/course/') + course.id} className='p-1 w-full flex gap-2 items-center justify-center self-center rounded-md bg-main text-white no-underline text-md text-center font-bold'>{self ? t('START_LEARNING') : t('GET_COURSE')} </Link>
            {!self && <button onClick={addToWishlist} className='p-1 self-center rounded-md bg-[#ffffff] font-bold text-main border-[1px] border-main no-underline text-md text-center flex items-center justify-center'>
                {adding ? (
                    <Oval
                        visible={true}
                        height="20"
                        width="20"
                        color="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                    />
                ) : !wished ? [
                    <HeartIcon style={{color: '#6622cf', fontSize: 20}}>Filled</HeartIcon>
                ] : [
                    <HeartFilledIcon style={{color: '#6622cf', fontSize: 20}}>Filled</HeartFilledIcon>
                ]}
            </button>}
        </div>
        </div>
    </div>
  )
}

export function CourseCardSkeleton(){
    return (
        <div className='bg-white max-w-[320px] w-[320px] max-md:max-w-[350px] animate-pulse flex flex-col p-2 rounded-md gap-2 shadow-lg h-[400px] transition-all cursor-pointer'>
        <div className='rounded-md h-1/2 w-full bg-[#acacac]'></div>
        <div className='h-4 w-1/4 bg-[#acacac]'></div>
        <div className='h-4 w-1/6 bg-[#acacac]'></div>
        {/* {noProg ? '' : self ? <ProgressBar completed={60} height={13} labelSize={10} bgColor='#198754' /> : <p className='text-black text-md font-bold'>ETB {price}</p> } */}
    </div>
    )
}
